import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Dollar: React.FC<IconProps> = ({
  color = '#fff',
  size = 18,
  className,
  style,
  ...rest
}) => {
  // Maintain aspect ratio from React Native version (18x29)
  const aspectRatio = 29 / 18
  const height = size * aspectRatio

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 18 29"
      fill="none"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath="url(#clip0_33430_60288)">
        <path
          d="M8.969 28.227c-.598 0-.93-.332-.93-.928v-1.127c-4.088-.431-6.58-2.718-7.311-5.9-.167-.596.199-.994.83-.994h2.06c.532 0 .831.298.998.862.398 1.524 1.661 2.452 3.422 2.817v-6.662c-3.755-1.127-6.845-2.585-6.845-6.927 0-3.546 2.791-6.131 6.845-6.529V1.712c0-.596.333-.928.93-.928h.699c.598 0 .93.332.93.928v1.16c3.39.464 5.815 2.585 6.546 5.568.2.63-.166.994-.797.994h-2.027c-.565 0-.83-.265-.997-.828-.332-1.226-1.296-2.121-2.725-2.519v6.629c4.353 1.292 7.377 2.75 7.377 6.794 0 3.679-2.858 6.297-7.377 6.662v1.127c0 .596-.332.928-.93.928h-.698zM5.147 8.937c0 1.757 1.163 2.52 2.891 3.05V5.953c-1.827.299-2.89 1.426-2.89 2.983zm5.45 14.12c2.127-.233 3.356-1.26 3.356-2.917 0-1.89-1.262-2.552-3.356-3.149v6.065z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_33430_60288">
          <path fill={color} d="M0 0H18V29H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
